const PAYMENTS_TRANSITION = 'naMotorInsurance/confirmPayments/transition/';
export const INITIALIZE_PAYMENTS = 'naMotorInsurance/confirmPayments/initialize/';

// Transitions
export const FORM_VALIDATE_TRANSITION_PAYMENTS = PAYMENTS_TRANSITION + 'validateForm';
export const FORM_INVALIDATE_TRANSITION_PAYMENTS = PAYMENTS_TRANSITION + 'invalidateForm';
export const validateForm = () => ({ type: FORM_VALIDATE_TRANSITION_PAYMENTS });
export const invalidateForm = () => ({ type: FORM_INVALIDATE_TRANSITION_PAYMENTS });

// Events
export const PAYMENTS_SET_VALUE = 'naMotorInsurance/payments/setValue/';
export const PAYMENTS_SET_VALID = 'naMotorInsurance/payments/setValid/';
export const KE_PAYMENTS_SET_VALUE = 'keMotorInsurance/payments/setValue/';

export const CONFIRMATION_MODAL_DISPLAY = PAYMENTS_SET_VALUE + 'confirmationModalDisplay';

// API Call actions STK PUSH
export const TRIGGER_PAYMENTS_STK_PUSH = PAYMENTS_SET_VALUE + 'triggerPaymentsStkPush';
export const TRIGGER_KE_PAYMENTS_STK_PUSH = KE_PAYMENTS_SET_VALUE + 'triggerPaymentsStkPush';
export const TRIGGER_NA_PAYMENTS_STK_PUSH = KE_PAYMENTS_SET_VALUE + 'triggerPaymentsStkPush';
export const TRIGGER_PAYMENTS_STK_PUSH_SUCCESS = PAYMENTS_SET_VALUE + 'triggerPaymentsStkPushSuccess';
export const TRIGGER_PAYMENTS_STK_PUSH_FAILURE = PAYMENTS_SET_VALUE + 'triggerPaymentsStkPushFailure';
export const API_PENDING_TRANSITION_PAYMENTS_PUSH = `${PAYMENTS_SET_VALUE}/apiTransition/push/pending`;
export const API_SUCCESS_TRANSITION_PAYMENTS_PUSH = `${PAYMENTS_SET_VALUE}/apiTransition/push/success`;
export const API_FAILURE_TRANSITION_PAYMENTS_PUSH = `${PAYMENTS_SET_VALUE}/apiTransition/push/failure`;
export const API_INITIALIZE_TRANSITION_PAYMENTS_PUSH = `${PAYMENTS_SET_VALUE}/apiTransition/initialize`;
export const TRIGGER_CONFIRM_ORDER = PAYMENTS_SET_VALUE + 'confirm/Order';
export const CONFIRM_ORDER_SUCCESS = PAYMENTS_SET_VALUE + 'confirm/Order/success';
export const CONFIRM_ORDER_FAILURE = PAYMENTS_SET_VALUE + 'confirm/Order/failure';

export const API_CONFIRM_ORDER_SUCCESS = PAYMENTS_SET_VALUE + '/api/confirm/Order/success';
export const API_CONFIRM_ORDER_FAILURE = PAYMENTS_SET_VALUE + '/api/confirm/Order/failure';
export const API_CONFIRM_ORDER_PENDING = PAYMENTS_SET_VALUE + '/api/confirm/Order/pending';
export const apiTransitionStkPush = {
    pending: () => ({
        type: API_PENDING_TRANSITION_PAYMENTS_PUSH,
    }),
    success: () => ({
        type: API_SUCCESS_TRANSITION_PAYMENTS_PUSH,
    }),
    failure: () => ({
        type: API_FAILURE_TRANSITION_PAYMENTS_PUSH,
    }),
    initialize: () => ({
        type: API_INITIALIZE_TRANSITION_PAYMENTS_PUSH,
    }),
};

export const apiTransitionOrderConfirmation = {
    pending: () => ({
        type: API_CONFIRM_ORDER_PENDING,
    }),
    success: () => ({
        type: API_CONFIRM_ORDER_SUCCESS,
    }),
    failure: () => ({
        type: API_CONFIRM_ORDER_FAILURE,
    }),
};

// API Call actions FLEX PAY status
export const CHECK_PAYMENTS_STATUS = PAYMENTS_SET_VALUE + 'checkPaymentsStatus';
export const CHECK_PAYMENTS_STATUS_SUCCESS = PAYMENTS_SET_VALUE + 'checkPaymentsStatusSuccess';
export const CHECK_PAYMENTS_STATUS_FAILURE = PAYMENTS_SET_VALUE + 'checkPaymentsStatusFailure';
export const API_PENDING_TRANSITION_PAYMENTS_STATUS = `${PAYMENTS_SET_VALUE}/apiTransition/flex-pay/status/pending`;
export const API_SUCCESS_TRANSITION_PAYMENTS_STATUS = `${PAYMENTS_SET_VALUE}/apiTransition/flex-pay/status/success`;
export const API_FAILURE_TRANSITION_PAYMENTS_STATUS = `${PAYMENTS_SET_VALUE}/apiTransition/flex-pay/status/failure`;
export const API_FAILURE_TRANSITION_PAYMENTS_STATUS_INITIAL = `${PAYMENTS_SET_VALUE}/apiTransition/flex-pay/status/initial`;

export const apiTransitionPaymentsStatus = {
    pending: () => ({
        type: API_PENDING_TRANSITION_PAYMENTS_STATUS,
    }),
    success: () => ({
        type: API_SUCCESS_TRANSITION_PAYMENTS_STATUS,
    }),
    failure: () => ({
        type: API_FAILURE_TRANSITION_PAYMENTS_STATUS,
    }),
    initialize: () => ({
        type: API_FAILURE_TRANSITION_PAYMENTS_STATUS_INITIAL,
    }),
};

export const transitionPaymentsForm = {
    formValid: () => ({
        type: FORM_VALIDATE_TRANSITION_PAYMENTS,
    }),
    formInvalid: () => ({
        type: FORM_INVALIDATE_TRANSITION_PAYMENTS,
    }),
};

// Form input  actions
export const PHONE_NUMBER_SET_VALUE = PAYMENTS_SET_VALUE + 'phoneNumber';
export const PHONE_NUMBER_SET_VALID = PAYMENTS_SET_VALID + 'phoneNumber';
export const TERMS_SET_VALUE = PAYMENTS_SET_VALUE + 'terms';
export const TERMS_SET_VALID = PAYMENTS_SET_VALID + 'terms';
export const SET_NETWORK_PROVIDER = PAYMENTS_SET_VALUE + 'networkProvider';
export const SET_NETWORK_PROVIDER_VALID = PAYMENTS_SET_VALID + 'networkProvider';
export const PAYMENT_METHOD_SET_VALUE = PAYMENTS_SET_VALUE + 'paymentMethod';
export const PAYMENT_METHOD_SET_VALID = PAYMENTS_SET_VALID + 'paymentMethod';
export const ACCOUNT_HOLDER_NAME_SET_VALUE = PAYMENTS_SET_VALUE + 'accountHolderName';
export const ACCOUNT_HOLDER_NAME_SET_VALID = PAYMENTS_SET_VALID + 'accountHolderName';
export const ACCOUNT_HOLDER_SURNAME_SET_VALUE = PAYMENTS_SET_VALUE + 'accountHolderSurname';
export const ACCOUNT_HOLDER_SURNAME_SET_VALID = PAYMENTS_SET_VALID + 'accountHolderSurname';
export const BANK_NAME_SET_VALUE = PAYMENTS_SET_VALUE + 'bankName';
export const BANK_NAME_SET_VALID = PAYMENTS_SET_VALID + 'bankName';
export const BRANCH_CODE_SET_VALUE = PAYMENTS_SET_VALUE + 'branchCode';
export const BRANCH_CODE_SET_VALID = PAYMENTS_SET_VALID + 'branchCode';
export const ACCOUNT_NUMBER_SET_VALUE = PAYMENTS_SET_VALUE + 'accountNumber';
export const ACCOUNT_NUMBER_SET_VALID = PAYMENTS_SET_VALID + 'accountNumber';
export const ACCOUNT_TYPE_SET_VALUE = PAYMENTS_SET_VALUE + 'accountType';
export const ACCOUNT_TYPE_SET_VALID = PAYMENTS_SET_VALID + 'accountType';
export const DEBIT_DAY_SET_VALUE = PAYMENTS_SET_VALUE + 'debitDay';
export const DEBIT_DAY_SET_VALID = PAYMENTS_SET_VALID + 'debitDay';
export const setPhoneNumberValue = (value) => ({ type: PHONE_NUMBER_SET_VALUE, value });
export const setPhoneNumberValid = (error) => ({ type: PHONE_NUMBER_SET_VALID, error });
export const setTermsValue = (value) => ({ type: TERMS_SET_VALUE, value });
export const setTermsValid = (error) => ({ type: TERMS_SET_VALID, error });
export const setNetworkProviderValue = (value) => ({ type: SET_NETWORK_PROVIDER, value });
export const setNetworkProviderValid = (error) => ({ type: SET_NETWORK_PROVIDER_VALID, error });
export const setPaymentMethodValue = (value) => ({ type: PAYMENT_METHOD_SET_VALUE, value });
export const setPaymentMethodValid = (error) => ({ type: PAYMENT_METHOD_SET_VALID, error });
export const setAccountHolderNameValue = (value) => ({ type: ACCOUNT_HOLDER_NAME_SET_VALUE, value });
export const setAccountHolderNameValid = (error) => ({ type: ACCOUNT_HOLDER_NAME_SET_VALID, error });
export const setAccountHolderSurnameValue = (value) => ({ type: ACCOUNT_HOLDER_SURNAME_SET_VALUE, value });
export const setAccountHolderSurnameValid = (error) => ({ type: ACCOUNT_HOLDER_SURNAME_SET_VALID, error });
export const setBankNameValue = (value) => ({ type: BANK_NAME_SET_VALUE, value });
export const setBankNameValid = (error) => ({ type: BANK_NAME_SET_VALID, error });
export const setBranchCodeValue = (value) => ({ type: BRANCH_CODE_SET_VALUE, value });
export const setBranchCodeValid = (error) => ({ type: BRANCH_CODE_SET_VALID, error });
export const setAccountNumberValue = (value) => ({ type: ACCOUNT_NUMBER_SET_VALUE, value });
export const setAccountNumberValid = (error) => ({ type: ACCOUNT_NUMBER_SET_VALID, error });
export const setAccountTypeValue = (value) => ({ type: ACCOUNT_TYPE_SET_VALUE, value });
export const setAccountTypeValid = (error) => ({ type: ACCOUNT_TYPE_SET_VALID, error });
export const setDebitDayValue = (value) => ({ type: DEBIT_DAY_SET_VALUE, value });
export const setDebitDayValid = (error) => ({ type: DEBIT_DAY_SET_VALID, error });

export const setConfirmationModalDisplay = (value) => ({
    type: CONFIRMATION_MODAL_DISPLAY,
    value,
})

// API actions triggers
export const triggerPaymentsStkPush = () => ({ type: TRIGGER_PAYMENTS_STK_PUSH });
export const triggerKePaymentsStkPush = () => ({ type: TRIGGER_KE_PAYMENTS_STK_PUSH });
export const triggerPaymentsStkPushSuccess = (value) => ({ type: TRIGGER_PAYMENTS_STK_PUSH_SUCCESS, value });
export const triggerPaymentsStkPushFailure = (error) => ({ type: TRIGGER_PAYMENTS_STK_PUSH_FAILURE, error });
export const checkPaymentsStatusSuccess = (value) => ({ type: CHECK_PAYMENTS_STATUS_SUCCESS, value });
export const checkPaymentsStatusFailure = (error) => ({ type: CHECK_PAYMENTS_STATUS_FAILURE, error });
export const initializePayments = () => ({ type: INITIALIZE_PAYMENTS });
export const checkPaymentsStatus = () => ({ type: CHECK_PAYMENTS_STATUS });

export const triggerConfirmOrder = () => ({ type: TRIGGER_CONFIRM_ORDER });
export const confirmOrderSuccess = (value) => ({ type: CONFIRM_ORDER_SUCCESS, value });
export const confirmOrderFailure = (error) => ({ type: CONFIRM_ORDER_FAILURE, error });
